import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

export const Artist: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['remuneration']});
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2" maxWidth="550px">
						{t('acpslandingpage_title_rewardingartists_standalone-web')}
					</LandingHeading>
					<LandingParagraph
						maxWidth="550px"
						color="text.neutral.primary.default"
					>
						{t('acpslandingpage_text_rewardingartists_standalone-web')}
					</LandingParagraph>
				</>
			}
		/>
	);
};
